export default __webpack_public_path__ + "static/media/sm.57bfdfd5.svg";